webpackJsonp(["filtered_search"],{

/***/ "./filtered_search/filtered_search_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./lib/utils/ajax_cache.js
var ajax_cache = __webpack_require__("./lib/utils/ajax_cache.js");

// CONCATENATED MODULE: ./droplab/plugins/ajax.js
/* eslint-disable */



var Ajax = {
  _loadData: function _loadData(data, config, self) {
    if (config.loadingTemplate) {
      var dataLoadingTemplate = self.hook.list.list.querySelector('[data-loading-template]');
      if (dataLoadingTemplate) dataLoadingTemplate.outerHTML = self.listTemplate;
    }

    if (!self.destroyed) self.hook.list[config.method].call(self.hook.list, data);
  },
  preprocessing: function preprocessing(config, data) {
    var results = data;

    if (config.preprocessing && !data.preprocessed) {
      results = config.preprocessing(data);
      ajax_cache["a" /* default */].override(config.endpoint, results);
    }

    return results;
  },
  init: function init(hook) {
    var self = this;
    self.destroyed = false;
    var config = hook.config.Ajax;
    this.hook = hook;
    if (!config || !config.endpoint || !config.method) {
      return;
    }
    if (config.method !== 'setData' && config.method !== 'addData') {
      return;
    }
    if (config.loadingTemplate) {
      var dynamicList = hook.list.list.querySelector('[data-dynamic]');
      var loadingTemplate = document.createElement('div');
      loadingTemplate.innerHTML = config.loadingTemplate;
      loadingTemplate.setAttribute('data-loading-template', '');
      this.listTemplate = dynamicList.outerHTML;
      dynamicList.outerHTML = loadingTemplate.outerHTML;
    }

    return ajax_cache["a" /* default */].retrieve(config.endpoint).then(self.preprocessing.bind(null, config)).then(function (data) {
      return self._loadData(data, config, self);
    }).catch(config.onError);
  },
  destroy: function destroy() {
    this.destroyed = true;
  }
};

/* harmony default export */ var ajax = (Ajax);
// CONCATENATED MODULE: ./droplab/plugins/filter.js
/* eslint-disable */

var Filter = {
  keydown: function keydown(e) {
    if (this.destroyed) return;

    var hiddenCount = 0;
    var dataHiddenCount = 0;

    var list = e.detail.hook.list;
    var data = list.data;
    var value = e.detail.hook.trigger.value.toLowerCase();
    var config = e.detail.hook.config.Filter;
    var matches = [];
    var filterFunction;
    // will only work on dynamically set data
    if (!data) {
      return;
    }

    if (config && config.filterFunction && typeof config.filterFunction === 'function') {
      filterFunction = config.filterFunction;
    } else {
      filterFunction = function filterFunction(o) {
        // cheap string search
        o.droplab_hidden = o[config.template].toLowerCase().indexOf(value) === -1;
        return o;
      };
    }

    dataHiddenCount = data.filter(function (o) {
      return !o.droplab_hidden;
    }).length;

    matches = data.map(function (o) {
      return filterFunction(o, value);
    });

    hiddenCount = matches.filter(function (o) {
      return !o.droplab_hidden;
    }).length;

    if (dataHiddenCount !== hiddenCount) {
      list.setData(matches);
      list.currentIndex = 0;
    }
  },

  debounceKeydown: function debounceKeydown(e) {
    if ([13, // enter
    16, // shift
    17, // ctrl
    18, // alt
    20, // caps lock
    37, // left arrow
    38, // up arrow
    39, // right arrow
    40, // down arrow
    91, // left window
    92, // right window
    93].indexOf(e.detail.which || e.detail.keyCode) > -1) return;

    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(this.keydown.bind(this, e), 200);
  },

  init: function init(hook) {
    var config = hook.config.Filter;

    if (!config || !config.template) return;

    this.hook = hook;
    this.destroyed = false;

    this.eventWrapper = {};
    this.eventWrapper.debounceKeydown = this.debounceKeydown.bind(this);

    this.hook.trigger.addEventListener('keydown.dl', this.eventWrapper.debounceKeydown);
    this.hook.trigger.addEventListener('mousedown.dl', this.eventWrapper.debounceKeydown);
  },

  destroy: function destroy() {
    if (this.timeout) clearTimeout(this.timeout);
    this.destroyed = true;

    this.hook.trigger.removeEventListener('keydown.dl', this.eventWrapper.debounceKeydown);
    this.hook.trigger.removeEventListener('mousedown.dl', this.eventWrapper.debounceKeydown);
  }
};

/* harmony default export */ var filter = (Filter);
// EXTERNAL MODULE: ./filtered_search/filtered_search_dropdown.js
var filtered_search_dropdown = __webpack_require__("./filtered_search/filtered_search_dropdown.js");
var filtered_search_dropdown_default = /*#__PURE__*/__webpack_require__.n(filtered_search_dropdown);

// CONCATENATED MODULE: ./filtered_search/dropdown_emoji.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var dropdown_emoji_DropdownEmoji = function (_gl$FilteredSearchDro) {
  _inherits(DropdownEmoji, _gl$FilteredSearchDro);

  function DropdownEmoji() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, DropdownEmoji);

    var _this = _possibleConstructorReturn(this, (DropdownEmoji.__proto__ || Object.getPrototypeOf(DropdownEmoji)).call(this, options));

    _this.config = {
      Ajax: {
        endpoint: (gon.relative_url_root || '') + '/autocomplete/award_emojis',
        method: 'setData',
        loadingTemplate: _this.loadingTemplate,
        onError: function onError() {
          /* eslint-disable no-new */
          new flash["a" /* default */]('An error occurred fetching the dropdown data.');
          /* eslint-enable no-new */
        }
      },
      Filter: {
        template: 'name'
      }
    };

    __webpack_require__.e/* import() */("emoji").then(__webpack_require__.bind(null, "./emoji/index.js")).then(function (_ref) {
      var glEmojiTag = _ref.glEmojiTag;
      _this.glEmojiTag = glEmojiTag;
    }).catch(function () {/* ignore error and leave emoji name in the search bar */});

    _this.unbindEvents();
    _this.bindEvents();
    return _this;
  }

  _createClass(DropdownEmoji, [{
    key: 'bindEvents',
    value: function bindEvents() {
      _get(DropdownEmoji.prototype.__proto__ || Object.getPrototypeOf(DropdownEmoji.prototype), 'bindEvents', this).call(this);

      this.listRenderedWrapper = this.listRendered.bind(this);
      this.dropdown.addEventListener('render.dl', this.listRenderedWrapper);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      this.dropdown.removeEventListener('render.dl', this.listRenderedWrapper);
      _get(DropdownEmoji.prototype.__proto__ || Object.getPrototypeOf(DropdownEmoji.prototype), 'unbindEvents', this).call(this);
    }
  }, {
    key: 'listRendered',
    value: function listRendered() {
      this.replaceEmojiElement();
    }
  }, {
    key: 'itemClicked',
    value: function itemClicked(e) {
      _get(DropdownEmoji.prototype.__proto__ || Object.getPrototypeOf(DropdownEmoji.prototype), 'itemClicked', this).call(this, e, function (selected) {
        var name = selected.querySelector('.js-data-value').innerText.trim();
        return gl.DropdownUtils.getEscapedText(name);
      });
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var forceShowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.droplab.changeHookList(this.hookId, this.dropdown, [ajax, filter], this.config);
      _get(DropdownEmoji.prototype.__proto__ || Object.getPrototypeOf(DropdownEmoji.prototype), 'renderContent', this).call(this, forceShowList);
    }
  }, {
    key: 'replaceEmojiElement',
    value: function replaceEmojiElement() {
      var _this2 = this;

      if (!this.glEmojiTag) return;

      // Replace empty gl-emoji tag to real content
      var dropdownItems = [].concat(_toConsumableArray(this.dropdown.querySelectorAll('.filter-dropdown-item')));
      dropdownItems.forEach(function (dropdownItem) {
        var name = dropdownItem.querySelector('.js-data-value').innerText;
        var emojiTag = _this2.glEmojiTag(name);
        var emojiElement = dropdownItem.querySelector('gl-emoji');
        emojiElement.outerHTML = emojiTag;
      });
    }
  }, {
    key: 'init',
    value: function init() {
      this.droplab.addHook(this.input, this.dropdown, [ajax, filter], this.config).init();
    }
  }]);

  return DropdownEmoji;
}(gl.FilteredSearchDropdown);

window.gl = window.gl || {};
gl.DropdownEmoji = dropdown_emoji_DropdownEmoji;
// CONCATENATED MODULE: ./filtered_search/dropdown_hint.js
var dropdown_hint__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function dropdown_hint__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function dropdown_hint__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function dropdown_hint__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var dropdown_hint_DropdownHint = function (_gl$FilteredSearchDro) {
  dropdown_hint__inherits(DropdownHint, _gl$FilteredSearchDro);

  function DropdownHint() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    dropdown_hint__classCallCheck(this, DropdownHint);

    var input = options.input,
        tokenKeys = options.tokenKeys;

    var _this = dropdown_hint__possibleConstructorReturn(this, (DropdownHint.__proto__ || Object.getPrototypeOf(DropdownHint)).call(this, options));

    _this.config = {
      Filter: {
        template: 'hint',
        filterFunction: gl.DropdownUtils.filterHint.bind(null, {
          input: input,
          allowedKeys: tokenKeys.getKeys()
        })
      }
    };
    _this.tokenKeys = tokenKeys;
    return _this;
  }

  dropdown_hint__createClass(DropdownHint, [{
    key: 'itemClicked',
    value: function itemClicked(e) {
      var selected = e.detail.selected;


      if (selected.tagName === 'LI') {
        if (selected.hasAttribute('data-value')) {
          this.dismissDropdown();
        } else if (selected.getAttribute('data-action') === 'submit') {
          this.dismissDropdown();
          this.dispatchFormSubmitEvent();
        } else {
          var token = selected.querySelector('.js-filter-hint').innerText.trim();
          var tag = selected.querySelector('.js-filter-tag').innerText.trim();

          if (tag.length) {
            // Get previous input values in the input field and convert them into visual tokens
            var previousInputValues = this.input.value.split(' ');
            var searchTerms = [];

            previousInputValues.forEach(function (value, index) {
              searchTerms.push(value);

              if (index === previousInputValues.length - 1 && token.indexOf(value.toLowerCase()) !== -1) {
                searchTerms.pop();
              }
            });

            if (searchTerms.length > 0) {
              gl.FilteredSearchVisualTokens.addSearchVisualToken(searchTerms.join(' '));
            }

            gl.FilteredSearchDropdownManager.addWordToInput(token.replace(':', ''), '', false, this.container);
          }
          this.dismissDropdown();
          this.dispatchInputEvent();
        }
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var dropdownData = this.tokenKeys.get().map(function (tokenKey) {
        return {
          icon: 'fa-' + tokenKey.icon,
          hint: tokenKey.key,
          tag: ':' + tokenKey.tag,
          type: tokenKey.type
        };
      });

      this.droplab.changeHookList(this.hookId, this.dropdown, [filter], this.config);
      this.droplab.setData(this.hookId, dropdownData);
    }
  }, {
    key: 'init',
    value: function init() {
      this.droplab.addHook(this.input, this.dropdown, [filter], this.config).init();
    }
  }]);

  return DropdownHint;
}(gl.FilteredSearchDropdown);

window.gl = window.gl || {};
gl.DropdownHint = dropdown_hint_DropdownHint;
// CONCATENATED MODULE: ./filtered_search/dropdown_non_user.js
var dropdown_non_user__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var dropdown_non_user__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function dropdown_non_user__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function dropdown_non_user__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function dropdown_non_user__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var dropdown_non_user_DropdownNonUser = function (_gl$FilteredSearchDro) {
  dropdown_non_user__inherits(DropdownNonUser, _gl$FilteredSearchDro);

  function DropdownNonUser() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    dropdown_non_user__classCallCheck(this, DropdownNonUser);

    var input = options.input,
        endpoint = options.endpoint,
        symbol = options.symbol,
        preprocessing = options.preprocessing;

    var _this = dropdown_non_user__possibleConstructorReturn(this, (DropdownNonUser.__proto__ || Object.getPrototypeOf(DropdownNonUser)).call(this, options));

    _this.symbol = symbol;
    _this.config = {
      Ajax: {
        endpoint: endpoint,
        method: 'setData',
        loadingTemplate: _this.loadingTemplate,
        preprocessing: preprocessing,
        onError: function onError() {
          /* eslint-disable no-new */
          new flash["a" /* default */]('An error occurred fetching the dropdown data.');
          /* eslint-enable no-new */
        }
      },
      Filter: {
        filterFunction: gl.DropdownUtils.filterWithSymbol.bind(null, _this.symbol, input),
        template: 'title'
      }
    };
    return _this;
  }

  dropdown_non_user__createClass(DropdownNonUser, [{
    key: 'itemClicked',
    value: function itemClicked(e) {
      var _this2 = this;

      dropdown_non_user__get(DropdownNonUser.prototype.__proto__ || Object.getPrototypeOf(DropdownNonUser.prototype), 'itemClicked', this).call(this, e, function (selected) {
        var title = selected.querySelector('.js-data-value').innerText.trim();
        return '' + _this2.symbol + gl.DropdownUtils.getEscapedText(title);
      });
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var forceShowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.droplab.changeHookList(this.hookId, this.dropdown, [ajax, filter], this.config);
      dropdown_non_user__get(DropdownNonUser.prototype.__proto__ || Object.getPrototypeOf(DropdownNonUser.prototype), 'renderContent', this).call(this, forceShowList);
    }
  }, {
    key: 'init',
    value: function init() {
      this.droplab.addHook(this.input, this.dropdown, [ajax, filter], this.config).init();
    }
  }]);

  return DropdownNonUser;
}(gl.FilteredSearchDropdown);

window.gl = window.gl || {};
gl.DropdownNonUser = dropdown_non_user_DropdownNonUser;
// CONCATENATED MODULE: ./droplab/plugins/ajax_filter.js
/* eslint-disable */


var AjaxFilter = {
  init: function init(hook) {
    this.destroyed = false;
    this.hook = hook;
    this.notLoading();

    this.eventWrapper = {};
    this.eventWrapper.debounceTrigger = this.debounceTrigger.bind(this);
    this.hook.trigger.addEventListener('keydown.dl', this.eventWrapper.debounceTrigger);
    this.hook.trigger.addEventListener('focus', this.eventWrapper.debounceTrigger);

    this.trigger(true);
  },

  notLoading: function notLoading() {
    this.loading = false;
  },

  debounceTrigger: function debounceTrigger(e) {
    var NON_CHARACTER_KEYS = [16, 17, 18, 20, 37, 38, 39, 40, 91, 93];
    var invalidKeyPressed = NON_CHARACTER_KEYS.indexOf(e.detail.which || e.detail.keyCode) > -1;
    var focusEvent = e.type === 'focus';
    if (invalidKeyPressed || this.loading) {
      return;
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(this.trigger.bind(this, focusEvent), 200);
  },

  trigger: function trigger(getEntireList) {
    var _this = this;

    var config = this.hook.config.AjaxFilter;
    var searchValue = this.trigger.value;
    if (!config || !config.endpoint || !config.searchKey) {
      return;
    }
    if (config.searchValueFunction) {
      searchValue = config.searchValueFunction();
    }
    if (config.loadingTemplate && this.hook.list.data === undefined || this.hook.list.data.length === 0) {
      var dynamicList = this.hook.list.list.querySelector('[data-dynamic]');
      var loadingTemplate = document.createElement('div');
      loadingTemplate.innerHTML = config.loadingTemplate;
      loadingTemplate.setAttribute('data-loading-template', true);
      this.listTemplate = dynamicList.outerHTML;
      dynamicList.outerHTML = loadingTemplate.outerHTML;
    }
    if (getEntireList) {
      searchValue = '';
    }
    if (config.searchKey === searchValue) {
      return this.list.show();
    }
    this.loading = true;
    var params = config.params || {};
    params[config.searchKey] = searchValue;
    var url = config.endpoint + this.buildParams(params);
    return ajax_cache["a" /* default */].retrieve(url).then(function (data) {
      _this._loadData(data, config);
      if (config.onLoadingFinished) {
        config.onLoadingFinished(data);
      }
    }).catch(config.onError);
  },

  _loadData: function _loadData(data, config) {
    var list = this.hook.list;
    if (config.loadingTemplate && list.data === undefined || list.data.length === 0) {
      var dataLoadingTemplate = list.list.querySelector('[data-loading-template]');
      if (dataLoadingTemplate) {
        dataLoadingTemplate.outerHTML = this.listTemplate;
      }
    }
    if (!this.destroyed) {
      var hookListChildren = list.list.children;
      var onlyDynamicList = hookListChildren.length === 1 && hookListChildren[0].hasAttribute('data-dynamic');
      if (onlyDynamicList && data.length === 0) {
        list.hide();
      }
      list.setData.call(list, data);
    }
    this.notLoading();
    list.currentIndex = 0;
  },


  buildParams: function buildParams(params) {
    if (!params) return '';
    var paramsArray = Object.keys(params).map(function (param) {
      return param + '=' + (params[param] || '');
    });
    return '?' + paramsArray.join('&');
  },

  destroy: function destroy() {
    if (this.timeout) clearTimeout(this.timeout);
    this.destroyed = true;

    this.hook.trigger.removeEventListener('keydown.dl', this.eventWrapper.debounceTrigger);
    this.hook.trigger.removeEventListener('focus', this.eventWrapper.debounceTrigger);
  }
};

/* harmony default export */ var ajax_filter = (AjaxFilter);
// CONCATENATED MODULE: ./lib/utils/dom_utils.js
/* eslint-disable import/prefer-default-export */

var addClassIfElementExists = function addClassIfElementExists(element, className) {
  if (element) {
    element.classList.add(className);
  }
};
// CONCATENATED MODULE: ./filtered_search/dropdown_user.js
var dropdown_user__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var dropdown_user__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function dropdown_user__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function dropdown_user__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function dropdown_user__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var dropdown_user_DropdownUser = function (_gl$FilteredSearchDro) {
  dropdown_user__inherits(DropdownUser, _gl$FilteredSearchDro);

  function DropdownUser() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    dropdown_user__classCallCheck(this, DropdownUser);

    var tokenKeys = options.tokenKeys;

    var _this = dropdown_user__possibleConstructorReturn(this, (DropdownUser.__proto__ || Object.getPrototypeOf(DropdownUser)).call(this, options));

    _this.config = {
      AjaxFilter: {
        endpoint: (gon.relative_url_root || '') + '/autocomplete/users.json',
        searchKey: 'search',
        params: {
          active: true,
          group_id: _this.getGroupId(),
          project_id: _this.getProjectId(),
          current_user: true
        },
        searchValueFunction: _this.getSearchInput.bind(_this),
        loadingTemplate: _this.loadingTemplate,
        onLoadingFinished: function onLoadingFinished() {
          _this.hideCurrentUser();
        },
        onError: function onError() {
          /* eslint-disable no-new */
          new flash["a" /* default */]('An error occurred fetching the dropdown data.');
          /* eslint-enable no-new */
        }
      }
    };
    _this.tokenKeys = tokenKeys;
    return _this;
  }

  dropdown_user__createClass(DropdownUser, [{
    key: 'hideCurrentUser',
    value: function hideCurrentUser() {
      addClassIfElementExists(this.dropdown.querySelector('.js-current-user'), 'hidden');
    }
  }, {
    key: 'itemClicked',
    value: function itemClicked(e) {
      dropdown_user__get(DropdownUser.prototype.__proto__ || Object.getPrototypeOf(DropdownUser.prototype), 'itemClicked', this).call(this, e, function (selected) {
        return selected.querySelector('.dropdown-light-content').innerText.trim();
      });
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var forceShowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.droplab.changeHookList(this.hookId, this.dropdown, [ajax_filter], this.config);
      dropdown_user__get(DropdownUser.prototype.__proto__ || Object.getPrototypeOf(DropdownUser.prototype), 'renderContent', this).call(this, forceShowList);
    }
  }, {
    key: 'getGroupId',
    value: function getGroupId() {
      return this.input.getAttribute('data-group-id');
    }
  }, {
    key: 'getProjectId',
    value: function getProjectId() {
      return this.input.getAttribute('data-project-id');
    }
  }, {
    key: 'getSearchInput',
    value: function getSearchInput() {
      var query = gl.DropdownUtils.getSearchInput(this.input);

      var _gl$FilteredSearchTok = gl.FilteredSearchTokenizer.processTokens(query, this.tokenKeys.get()),
          lastToken = _gl$FilteredSearchTok.lastToken;

      var value = lastToken || '';

      if (value[0] === '@') {
        value = value.slice(1);
      }

      // Removes the first character if it is a quotation so that we can search
      // with multiple words
      if (value[0] === '"' || value[0] === '\'') {
        value = value.slice(1);
      }

      return value;
    }
  }, {
    key: 'init',
    value: function init() {
      this.droplab.addHook(this.input, this.dropdown, [ajax_filter], this.config).init();
    }
  }]);

  return DropdownUser;
}(gl.FilteredSearchDropdown);

window.gl = window.gl || {};
gl.DropdownUser = dropdown_user_DropdownUser;
// EXTERNAL MODULE: ./filtered_search/dropdown_utils.js
var dropdown_utils = __webpack_require__("./filtered_search/dropdown_utils.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: ./droplab/drop_lab.js + 7 modules
var drop_lab = __webpack_require__("./droplab/drop_lab.js");

// EXTERNAL MODULE: ./filtered_search/container.js
var container = __webpack_require__("./filtered_search/container.js");

// CONCATENATED MODULE: ./filtered_search/filtered_search_dropdown_manager.js
var filtered_search_dropdown_manager__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtered_search_dropdown_manager__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var filtered_search_dropdown_manager_FilteredSearchDropdownManager = function () {
  function FilteredSearchDropdownManager() {
    var baseEndpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var tokenizer = arguments[1];
    var page = arguments[2];
    var isGroup = arguments[3];
    var filteredSearchTokenKeys = arguments[4];

    filtered_search_dropdown_manager__classCallCheck(this, FilteredSearchDropdownManager);

    this.container = container["a" /* default */].container;
    this.baseEndpoint = baseEndpoint.replace(/\/$/, '');
    this.tokenizer = tokenizer;
    this.filteredSearchTokenKeys = filteredSearchTokenKeys;
    this.filteredSearchInput = this.container.querySelector('.filtered-search');
    this.page = page;

    this.setupMapping();

    this.cleanupWrapper = this.cleanup.bind(this);
    document.addEventListener('beforeunload', this.cleanupWrapper);
  }

  filtered_search_dropdown_manager__createClass(FilteredSearchDropdownManager, [{
    key: 'cleanup',
    value: function cleanup() {
      if (this.droplab) {
        this.droplab.destroy();
        this.droplab = null;
      }

      this.setupMapping();

      document.removeEventListener('beforeunload', this.cleanupWrapper);
    }
  }, {
    key: 'setupMapping',
    value: function setupMapping() {
      var supportedTokens = this.filteredSearchTokenKeys.getKeys();
      var allowedMappings = {
        hint: {
          reference: null,
          gl: 'DropdownHint',
          element: this.container.querySelector('#js-dropdown-hint')
        }
      };
      var availableMappings = {
        author: {
          reference: null,
          gl: 'DropdownUser',
          element: this.container.querySelector('#js-dropdown-author')
        },
        assignee: {
          reference: null,
          gl: 'DropdownUser',
          element: this.container.querySelector('#js-dropdown-assignee')
        },
        milestone: {
          reference: null,
          gl: 'DropdownNonUser',
          extraArguments: {
            endpoint: this.baseEndpoint + '/milestones.json',
            symbol: '%'
          },
          element: this.container.querySelector('#js-dropdown-milestone')
        },
        label: {
          reference: null,
          gl: 'DropdownNonUser',
          extraArguments: {
            endpoint: this.baseEndpoint + '/labels.json',
            symbol: '~',
            preprocessing: gl.DropdownUtils.duplicateLabelPreprocessing
          },
          element: this.container.querySelector('#js-dropdown-label')
        },
        'my-reaction': {
          reference: null,
          gl: 'DropdownEmoji',
          element: this.container.querySelector('#js-dropdown-my-reaction')
        }
      };

      supportedTokens.forEach(function (type) {
        if (availableMappings[type]) {
          allowedMappings[type] = availableMappings[type];
        }
      });

      this.mapping = allowedMappings;
    }
  }, {
    key: 'updateCurrentDropdownOffset',
    value: function updateCurrentDropdownOffset() {
      this.updateDropdownOffset(this.currentDropdown);
    }
  }, {
    key: 'updateDropdownOffset',
    value: function updateDropdownOffset(key) {
      // Always align dropdown with the input field
      var offset = this.filteredSearchInput.getBoundingClientRect().left - this.container.querySelector('.scroll-container').getBoundingClientRect().left;

      var maxInputWidth = 240;
      var currentDropdownWidth = this.mapping[key].element.clientWidth || maxInputWidth;

      // Make sure offset never exceeds the input container
      var offsetMaxWidth = this.container.querySelector('.scroll-container').clientWidth - currentDropdownWidth;
      if (offsetMaxWidth < offset) {
        offset = offsetMaxWidth;
      }

      this.mapping[key].reference.setOffset(offset);
    }
  }, {
    key: 'load',
    value: function load(key) {
      var firstLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var mappingKey = this.mapping[key];
      var glClass = mappingKey.gl;
      var element = mappingKey.element;
      var forceShowList = false;

      if (!mappingKey.reference) {
        var defaultArguments = {
          droplab: this.droplab,
          dropdown: element,
          input: this.filteredSearchInput,
          tokenKeys: this.filteredSearchTokenKeys,
          filter: key
        };
        var extraArguments = mappingKey.extraArguments || {};
        var glArguments = Object.assign({}, defaultArguments, extraArguments);

        // Passing glArguments to `new gl[glClass](<arguments>)`
        mappingKey.reference = new (Function.prototype.bind.apply(gl[glClass], [null, glArguments]))();
      }

      if (firstLoad) {
        mappingKey.reference.init();
      }

      if (this.currentDropdown === 'hint') {
        // Force the dropdown to show if it was clicked from the hint dropdown
        forceShowList = true;
      }

      this.updateDropdownOffset(key);
      mappingKey.reference.render(firstLoad, forceShowList);

      this.currentDropdown = key;
    }
  }, {
    key: 'loadDropdown',
    value: function loadDropdown() {
      var dropdownName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var firstLoad = false;

      if (!this.droplab) {
        firstLoad = true;
        this.droplab = new drop_lab["a" /* default */]();
      }

      var match = this.filteredSearchTokenKeys.searchByKey(dropdownName.toLowerCase());
      var shouldOpenFilterDropdown = match && this.currentDropdown !== match.key && this.mapping[match.key];
      var shouldOpenHintDropdown = !match && this.currentDropdown !== 'hint';

      if (shouldOpenFilterDropdown || shouldOpenHintDropdown) {
        var key = match && match.key ? match.key : 'hint';
        this.load(key, firstLoad);
      }
    }
  }, {
    key: 'setDropdown',
    value: function setDropdown() {
      var query = gl.DropdownUtils.getSearchQuery(true);

      var _tokenizer$processTok = this.tokenizer.processTokens(query, this.filteredSearchTokenKeys.getKeys()),
          lastToken = _tokenizer$processTok.lastToken,
          searchToken = _tokenizer$processTok.searchToken;

      if (this.currentDropdown) {
        this.updateCurrentDropdownOffset();
      }

      if (lastToken === searchToken && lastToken !== null) {
        // Token is not fully initialized yet because it has no value
        // Eg. token = 'label:'

        var split = lastToken.split(':');
        var dropdownName = underscore_default.a.last(split[0].split(' '));
        this.loadDropdown(split.length > 1 ? dropdownName : '');
      } else if (lastToken) {
        // Token has been initialized into an object because it has a value
        this.loadDropdown(lastToken.key);
      } else {
        this.loadDropdown('hint');
      }
    }
  }, {
    key: 'resetDropdowns',
    value: function resetDropdowns() {
      if (!this.currentDropdown) {
        return;
      }

      // Force current dropdown to hide
      this.mapping[this.currentDropdown].reference.hideDropdown();

      // Re-Load dropdown
      this.setDropdown();

      // Reset filters for current dropdown
      this.mapping[this.currentDropdown].reference.resetFilters();

      // Reposition dropdown so that it is aligned with cursor
      this.updateDropdownOffset(this.currentDropdown);
    }
  }, {
    key: 'destroyDroplab',
    value: function destroyDroplab() {
      this.droplab.destroy();
    }
  }], [{
    key: 'addWordToInput',
    value: function addWordToInput(tokenName) {
      var tokenValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var clicked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var input = container["a" /* default */].container.querySelector('.filtered-search');

      gl.FilteredSearchVisualTokens.addFilterVisualToken(tokenName, tokenValue);
      input.value = '';

      if (clicked) {
        gl.FilteredSearchVisualTokens.moveInputToTheRight();
      }
    }
  }]);

  return FilteredSearchDropdownManager;
}();

window.gl = window.gl || {};
gl.FilteredSearchDropdownManager = filtered_search_dropdown_manager_FilteredSearchDropdownManager;
// EXTERNAL MODULE: ./lib/utils/url_utility.js
var url_utility = __webpack_require__("./lib/utils/url_utility.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// CONCATENATED MODULE: ./filtered_search/event_hub.js


/* harmony default export */ var event_hub = (new vue_esm["a" /* default */]());
// CONCATENATED MODULE: ./filtered_search/components/recent_searches_dropdown_content.js


/* harmony default export */ var recent_searches_dropdown_content = ({
  name: 'RecentSearchesDropdownContent',

  props: {
    items: {
      type: Array,
      required: true
    },
    isLocalStorageAvailable: {
      type: Boolean,
      required: false,
      default: true
    },
    allowedKeys: {
      type: Array,
      required: true
    }
  },

  computed: {
    processedItems: function processedItems() {
      var _this = this;

      return this.items.map(function (item) {
        var _gl$FilteredSearchTok = gl.FilteredSearchTokenizer.processTokens(item, _this.allowedKeys),
            tokens = _gl$FilteredSearchTok.tokens,
            searchToken = _gl$FilteredSearchTok.searchToken;

        var resultantTokens = tokens.map(function (token) {
          return {
            prefix: token.key + ':',
            suffix: '' + token.symbol + token.value
          };
        });

        return {
          text: item,
          tokens: resultantTokens,
          searchToken: searchToken
        };
      });
    },
    hasItems: function hasItems() {
      return this.items.length > 0;
    }
  },

  methods: {
    onItemActivated: function onItemActivated(text) {
      event_hub.$emit('recentSearchesItemSelected', text);
    },
    onRequestClearRecentSearches: function onRequestClearRecentSearches(e) {
      // Stop the dropdown from closing
      e.stopPropagation();

      event_hub.$emit('requestClearRecentSearches');
    }
  },

  template: '\n    <div>\n      <div\n        v-if="!isLocalStorageAvailable"\n        class="dropdown-info-note">\n        This feature requires local storage to be enabled\n      </div>\n      <ul v-else-if="hasItems">\n        <li\n          v-for="(item, index) in processedItems"\n          :key="index">\n          <button\n            type="button"\n            class="filtered-search-history-dropdown-item"\n            @click="onItemActivated(item.text)">\n            <span>\n              <span\n                v-for="(token, tokenIndex) in item.tokens"\n                class="filtered-search-history-dropdown-token">\n                <span class="name">{{ token.prefix }}</span><span class="value">{{ token.suffix }}</span>\n              </span>\n            </span>\n            <span class="filtered-search-history-dropdown-search-token">\n              {{ item.searchToken }}\n            </span>\n          </button>\n        </li>\n        <li class="divider"></li>\n        <li>\n          <button\n            type="button"\n            class="filtered-search-history-clear-button"\n            @click="onRequestClearRecentSearches($event)">\n            Clear recent searches\n          </button>\n        </li>\n      </ul>\n      <div\n        v-else\n        class="dropdown-info-note">\n        \u60A8\u6700\u8FD1\u6CA1\u6709\u4EFB\u4F55\u641C\u7D22\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: ./filtered_search/recent_searches_root.js
var recent_searches_root__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function recent_searches_root__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var recent_searches_root_RecentSearchesRoot = function () {
  function RecentSearchesRoot(recentSearchesStore, recentSearchesService, wrapperElement) {
    recent_searches_root__classCallCheck(this, RecentSearchesRoot);

    this.store = recentSearchesStore;
    this.service = recentSearchesService;
    this.wrapperElement = wrapperElement;
  }

  recent_searches_root__createClass(RecentSearchesRoot, [{
    key: 'init',
    value: function init() {
      this.bindEvents();
      this.render();
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.onRequestClearRecentSearchesWrapper = this.onRequestClearRecentSearches.bind(this);

      event_hub.$on('requestClearRecentSearches', this.onRequestClearRecentSearchesWrapper);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      event_hub.$off('requestClearRecentSearches', this.onRequestClearRecentSearchesWrapper);
    }
  }, {
    key: 'render',
    value: function render() {
      var state = this.store.state;
      this.vm = new vue_esm["a" /* default */]({
        el: this.wrapperElement,
        components: {
          'recent-searches-dropdown-content': recent_searches_dropdown_content
        },
        data: function data() {
          return state;
        },

        template: '\n        <recent-searches-dropdown-content\n          :items="recentSearches"\n          :is-local-storage-available="isLocalStorageAvailable"\n          :allowed-keys="allowedKeys"\n          />\n      '
      });
    }
  }, {
    key: 'onRequestClearRecentSearches',
    value: function onRequestClearRecentSearches() {
      var resultantSearches = this.store.setRecentSearches([]);
      this.service.save(resultantSearches);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.unbindEvents();
      if (this.vm) {
        this.vm.$destroy();
      }
    }
  }]);

  return RecentSearchesRoot;
}();

/* harmony default export */ var recent_searches_root = (recent_searches_root_RecentSearchesRoot);
// CONCATENATED MODULE: ./filtered_search/filtered_search_token_keys.js
var filtered_search_token_keys__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtered_search_token_keys__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var filtered_search_token_keys_tokenKeys = [{
  key: 'author',
  type: 'string',
  param: 'username',
  symbol: '@',
  icon: 'pencil',
  tag: '@author'
}, {
  key: 'assignee',
  type: 'string',
  param: 'username',
  symbol: '@',
  icon: 'user',
  tag: '@assignee'
}, {
  key: 'milestone',
  type: 'string',
  param: 'title',
  symbol: '%',
  icon: 'clock-o',
  tag: '%milestone'
}, {
  key: 'label',
  type: 'array',
  param: 'name[]',
  symbol: '~',
  icon: 'tag',
  tag: '~label'
}];

if (gon.current_user_id) {
  // Appending tokenkeys only logged-in
  filtered_search_token_keys_tokenKeys.push({
    key: 'my-reaction',
    type: 'string',
    param: 'emoji',
    symbol: '',
    icon: 'thumbs-up',
    tag: 'emoji'
  });
}

var alternativeTokenKeys = [{
  key: 'label',
  type: 'string',
  param: 'name',
  symbol: '~'
}];

var tokenKeysWithAlternative = filtered_search_token_keys_tokenKeys.concat(alternativeTokenKeys);

var conditions = [{
  url: 'assignee_id=0',
  tokenKey: 'assignee',
  value: 'none'
}, {
  url: 'milestone_title=No+Milestone',
  tokenKey: 'milestone',
  value: 'none'
}, {
  url: 'milestone_title=%23upcoming',
  tokenKey: 'milestone',
  value: 'upcoming'
}, {
  url: 'milestone_title=%23started',
  tokenKey: 'milestone',
  value: 'started'
}, {
  url: 'label_name[]=No+Label',
  tokenKey: 'label',
  value: 'none'
}];

var FilteredSearchTokenKeys = function () {
  function FilteredSearchTokenKeys() {
    filtered_search_token_keys__classCallCheck(this, FilteredSearchTokenKeys);
  }

  filtered_search_token_keys__createClass(FilteredSearchTokenKeys, null, [{
    key: 'get',
    value: function get() {
      return filtered_search_token_keys_tokenKeys;
    }
  }, {
    key: 'getKeys',
    value: function getKeys() {
      return filtered_search_token_keys_tokenKeys.map(function (i) {
        return i.key;
      });
    }
  }, {
    key: 'getAlternatives',
    value: function getAlternatives() {
      return alternativeTokenKeys;
    }
  }, {
    key: 'getConditions',
    value: function getConditions() {
      return conditions;
    }
  }, {
    key: 'searchByKey',
    value: function searchByKey(key) {
      return filtered_search_token_keys_tokenKeys.find(function (tokenKey) {
        return tokenKey.key === key;
      }) || null;
    }
  }, {
    key: 'searchBySymbol',
    value: function searchBySymbol(symbol) {
      return filtered_search_token_keys_tokenKeys.find(function (tokenKey) {
        return tokenKey.symbol === symbol;
      }) || null;
    }
  }, {
    key: 'searchByKeyParam',
    value: function searchByKeyParam(keyParam) {
      return tokenKeysWithAlternative.find(function (tokenKey) {
        var tokenKeyParam = tokenKey.key;

        // Replace hyphen with underscore to compare keyParam with tokenKeyParam
        // e.g. 'my-reaction' => 'my_reaction'
        tokenKeyParam = tokenKeyParam.replace('-', '_');

        if (tokenKey.param) {
          tokenKeyParam += '_' + tokenKey.param;
        }

        return keyParam === tokenKeyParam;
      }) || null;
    }
  }, {
    key: 'searchByConditionUrl',
    value: function searchByConditionUrl(url) {
      return conditions.find(function (condition) {
        return condition.url === url;
      }) || null;
    }
  }, {
    key: 'searchByConditionKeyValue',
    value: function searchByConditionKeyValue(key, value) {
      return conditions.find(function (condition) {
        return condition.tokenKey === key && condition.value === value;
      }) || null;
    }
  }]);

  return FilteredSearchTokenKeys;
}();

/* harmony default export */ var filtered_search_token_keys = (FilteredSearchTokenKeys);
// CONCATENATED MODULE: ./filtered_search/stores/recent_searches_store.js
var recent_searches_store__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function recent_searches_store__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var recent_searches_store_RecentSearchesStore = function () {
  function RecentSearchesStore() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var allowedKeys = arguments[1];

    recent_searches_store__classCallCheck(this, RecentSearchesStore);

    this.state = Object.assign({
      isLocalStorageAvailable: true,
      recentSearches: [],
      allowedKeys: allowedKeys
    }, initialState);
  }

  recent_searches_store__createClass(RecentSearchesStore, [{
    key: 'addRecentSearch',
    value: function addRecentSearch(newSearch) {
      this.setRecentSearches([newSearch].concat(this.state.recentSearches));

      return this.state.recentSearches;
    }
  }, {
    key: 'setRecentSearches',
    value: function setRecentSearches() {
      var searches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var trimmedSearches = searches.map(function (search) {
        return search.trim();
      });
      this.state.recentSearches = underscore_default.a.uniq(trimmedSearches).slice(0, 5);
      return this.state.recentSearches;
    }
  }]);

  return RecentSearchesStore;
}();

/* harmony default export */ var recent_searches_store = (recent_searches_store_RecentSearchesStore);
// CONCATENATED MODULE: ./filtered_search/services/recent_searches_service_error.js
function recent_searches_service_error__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecentSearchesServiceError = function RecentSearchesServiceError(message) {
  recent_searches_service_error__classCallCheck(this, RecentSearchesServiceError);

  this.name = 'RecentSearchesServiceError';
  this.message = message || 'Recent Searches Service is unavailable';
};

// Can't use `extends` for builtin prototypes and get true inheritance yet


RecentSearchesServiceError.prototype = Error.prototype;

/* harmony default export */ var recent_searches_service_error = (RecentSearchesServiceError);
// EXTERNAL MODULE: ./lib/utils/accessor.js
var accessor = __webpack_require__("./lib/utils/accessor.js");

// CONCATENATED MODULE: ./filtered_search/services/recent_searches_service.js
var recent_searches_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function recent_searches_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var recent_searches_service_RecentSearchesService = function () {
  function RecentSearchesService() {
    var localStorageKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'issuable-recent-searches';

    recent_searches_service__classCallCheck(this, RecentSearchesService);

    this.localStorageKey = localStorageKey;
  }

  recent_searches_service__createClass(RecentSearchesService, [{
    key: 'fetch',
    value: function fetch() {
      if (!RecentSearchesService.isAvailable()) {
        var error = new recent_searches_service_error();
        return Promise.reject(error);
      }

      var input = window.localStorage.getItem(this.localStorageKey);

      var searches = [];
      if (input && input.length > 0) {
        try {
          searches = JSON.parse(input);
        } catch (err) {
          return Promise.reject(err);
        }
      }

      return Promise.resolve(searches);
    }
  }, {
    key: 'save',
    value: function save() {
      var searches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (!RecentSearchesService.isAvailable()) return;

      window.localStorage.setItem(this.localStorageKey, JSON.stringify(searches));
    }
  }], [{
    key: 'isAvailable',
    value: function isAvailable() {
      return accessor["a" /* default */].isLocalStorageAccessSafe();
    }
  }]);

  return RecentSearchesService;
}();

/* harmony default export */ var recent_searches_service = (recent_searches_service_RecentSearchesService);
// CONCATENATED MODULE: ./filtered_search/filtered_search_manager.js
var filtered_search_manager__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtered_search_manager__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }












var filtered_search_manager_FilteredSearchManager = function () {
  function FilteredSearchManager(_ref) {
    var page = _ref.page,
        _ref$filteredSearchTo = _ref.filteredSearchTokenKeys,
        filteredSearchTokenKeys = _ref$filteredSearchTo === undefined ? filtered_search_token_keys : _ref$filteredSearchTo,
        _ref$stateFiltersSele = _ref.stateFiltersSelector,
        stateFiltersSelector = _ref$stateFiltersSele === undefined ? '.issues-state-filters' : _ref$stateFiltersSele;

    filtered_search_manager__classCallCheck(this, FilteredSearchManager);

    this.isGroup = false;
    this.states = ['opened', 'closed', 'merged', 'all'];

    this.page = page;
    this.container = container["a" /* default */].container;
    this.filteredSearchInput = this.container.querySelector('.filtered-search');
    this.filteredSearchInputForm = this.filteredSearchInput.form;
    this.clearSearchButton = this.container.querySelector('.clear-search');
    this.tokensContainer = this.container.querySelector('.tokens-container');
    this.filteredSearchTokenKeys = filteredSearchTokenKeys;
    this.stateFiltersSelector = stateFiltersSelector;
    this.recentsStorageKeyNames = {
      issues: 'issue-recent-searches',
      merge_requests: 'merge-request-recent-searches'
    };

    this.recentSearchesStore = new recent_searches_store({
      isLocalStorageAvailable: recent_searches_service.isAvailable(),
      allowedKeys: this.filteredSearchTokenKeys.getKeys()
    });
    this.searchHistoryDropdownElement = document.querySelector('.js-filtered-search-history-dropdown');
    var fullPath = this.searchHistoryDropdownElement ? this.searchHistoryDropdownElement.dataset.fullPath : 'project';
    var recentSearchesKey = fullPath + '-' + this.recentsStorageKeyNames[this.page];
    this.recentSearchesService = new recent_searches_service(recentSearchesKey);
  }

  filtered_search_manager__createClass(FilteredSearchManager, [{
    key: 'setup',
    value: function setup() {
      var _this = this;

      // Fetch recent searches from localStorage
      this.fetchingRecentSearchesPromise = this.recentSearchesService.fetch().catch(function (error) {
        if (error.name === 'RecentSearchesServiceError') return undefined;
        // eslint-disable-next-line no-new
        new flash["a" /* default */]('An error occurred while parsing recent searches');
        // Gracefully fail to empty array
        return [];
      }).then(function (searches) {
        if (!searches) {
          return;
        }

        // Put any searches that may have come in before
        // we fetched the saved searches ahead of the already saved ones
        var resultantSearches = _this.recentSearchesStore.setRecentSearches(_this.recentSearchesStore.state.recentSearches.concat(searches));
        _this.recentSearchesService.save(resultantSearches);
      });

      if (this.filteredSearchInput) {
        this.tokenizer = gl.FilteredSearchTokenizer;
        this.dropdownManager = new gl.FilteredSearchDropdownManager(this.filteredSearchInput.getAttribute('data-base-endpoint') || '', this.tokenizer, this.page, this.isGroup, this.filteredSearchTokenKeys);

        this.recentSearchesRoot = new recent_searches_root(this.recentSearchesStore, this.recentSearchesService, this.searchHistoryDropdownElement);
        this.recentSearchesRoot.init();

        this.bindEvents();
        this.loadSearchParamsFromURL();
        this.dropdownManager.setDropdown();

        this.cleanupWrapper = this.cleanup.bind(this);
        document.addEventListener('beforeunload', this.cleanupWrapper);
      }
    }
  }, {
    key: 'cleanup',
    value: function cleanup() {
      this.unbindEvents();
      document.removeEventListener('beforeunload', this.cleanupWrapper);

      if (this.recentSearchesRoot) {
        this.recentSearchesRoot.destroy();
      }
    }
  }, {
    key: 'bindStateEvents',
    value: function bindStateEvents() {
      var _this2 = this;

      this.stateFilters = document.querySelector('.container-fluid ' + this.stateFiltersSelector);

      if (this.stateFilters) {
        this.searchStateWrapper = this.searchState.bind(this);

        this.applyToStateFilters(function (filterEl) {
          filterEl.addEventListener('click', _this2.searchStateWrapper);
        });
      }
    }
  }, {
    key: 'unbindStateEvents',
    value: function unbindStateEvents() {
      var _this3 = this;

      if (this.stateFilters) {
        this.applyToStateFilters(function (filterEl) {
          filterEl.removeEventListener('click', _this3.searchStateWrapper);
        });
      }
    }
  }, {
    key: 'applyToStateFilters',
    value: function applyToStateFilters(callback) {
      var _this4 = this;

      this.stateFilters.querySelectorAll('a[data-state]').forEach(function (filterEl) {
        if (_this4.states.indexOf(filterEl.dataset.state) > -1) {
          callback(filterEl);
        }
      });
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.setDropdownWrapper = this.dropdownManager.setDropdown.bind(this.dropdownManager);
      this.toggleClearSearchButtonWrapper = this.toggleClearSearchButton.bind(this);
      this.handleInputPlaceholderWrapper = this.handleInputPlaceholder.bind(this);
      this.handleInputVisualTokenWrapper = this.handleInputVisualToken.bind(this);
      this.checkForEnterWrapper = this.checkForEnter.bind(this);
      this.onClearSearchWrapper = this.onClearSearch.bind(this);
      this.checkForBackspaceWrapper = this.checkForBackspace.call(this);
      this.removeSelectedTokenKeydownWrapper = this.removeSelectedTokenKeydown.bind(this);
      this.unselectEditTokensWrapper = this.unselectEditTokens.bind(this);
      this.editTokenWrapper = this.editToken.bind(this);
      this.tokenChange = this.tokenChange.bind(this);
      this.addInputContainerFocusWrapper = this.addInputContainerFocus.bind(this);
      this.removeInputContainerFocusWrapper = this.removeInputContainerFocus.bind(this);
      this.onrecentSearchesItemSelectedWrapper = this.onrecentSearchesItemSelected.bind(this);
      this.removeTokenWrapper = this.removeToken.bind(this);

      this.filteredSearchInputForm.addEventListener('submit', this.handleFormSubmit);
      this.filteredSearchInput.addEventListener('input', this.setDropdownWrapper);
      this.filteredSearchInput.addEventListener('input', this.toggleClearSearchButtonWrapper);
      this.filteredSearchInput.addEventListener('input', this.handleInputPlaceholderWrapper);
      this.filteredSearchInput.addEventListener('input', this.handleInputVisualTokenWrapper);
      this.filteredSearchInput.addEventListener('keydown', this.checkForEnterWrapper);
      this.filteredSearchInput.addEventListener('keyup', this.checkForBackspaceWrapper);
      this.filteredSearchInput.addEventListener('click', this.tokenChange);
      this.filteredSearchInput.addEventListener('keyup', this.tokenChange);
      this.filteredSearchInput.addEventListener('focus', this.addInputContainerFocusWrapper);
      this.tokensContainer.addEventListener('click', this.removeTokenWrapper);
      this.tokensContainer.addEventListener('click', this.editTokenWrapper);
      this.clearSearchButton.addEventListener('click', this.onClearSearchWrapper);
      document.addEventListener('click', this.unselectEditTokensWrapper);
      document.addEventListener('click', this.removeInputContainerFocusWrapper);
      document.addEventListener('keydown', this.removeSelectedTokenKeydownWrapper);
      event_hub.$on('recentSearchesItemSelected', this.onrecentSearchesItemSelectedWrapper);

      this.bindStateEvents();
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      this.filteredSearchInputForm.removeEventListener('submit', this.handleFormSubmit);
      this.filteredSearchInput.removeEventListener('input', this.setDropdownWrapper);
      this.filteredSearchInput.removeEventListener('input', this.toggleClearSearchButtonWrapper);
      this.filteredSearchInput.removeEventListener('input', this.handleInputPlaceholderWrapper);
      this.filteredSearchInput.removeEventListener('input', this.handleInputVisualTokenWrapper);
      this.filteredSearchInput.removeEventListener('keydown', this.checkForEnterWrapper);
      this.filteredSearchInput.removeEventListener('keyup', this.checkForBackspaceWrapper);
      this.filteredSearchInput.removeEventListener('click', this.tokenChange);
      this.filteredSearchInput.removeEventListener('keyup', this.tokenChange);
      this.filteredSearchInput.removeEventListener('focus', this.addInputContainerFocusWrapper);
      this.tokensContainer.removeEventListener('click', this.removeTokenWrapper);
      this.tokensContainer.removeEventListener('click', this.editTokenWrapper);
      this.clearSearchButton.removeEventListener('click', this.onClearSearchWrapper);
      document.removeEventListener('click', this.unselectEditTokensWrapper);
      document.removeEventListener('click', this.removeInputContainerFocusWrapper);
      document.removeEventListener('keydown', this.removeSelectedTokenKeydownWrapper);
      event_hub.$off('recentSearchesItemSelected', this.onrecentSearchesItemSelectedWrapper);

      this.unbindStateEvents();
    }
  }, {
    key: 'checkForBackspace',
    value: function checkForBackspace() {
      var _this5 = this;

      var backspaceCount = 0;

      // closure for keeping track of the number of backspace keystrokes
      return function (e) {
        // 8 = Backspace Key
        // 46 = Delete Key
        if (e.keyCode === 8 || e.keyCode === 46) {
          var _gl$FilteredSearchVis = gl.FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
              lastVisualToken = _gl$FilteredSearchVis.lastVisualToken;

          var _gl$DropdownUtils$get = gl.DropdownUtils.getVisualTokenValues(lastVisualToken),
              tokenName = _gl$DropdownUtils$get.tokenName,
              tokenValue = _gl$DropdownUtils$get.tokenValue;

          var canEdit = tokenName && _this5.canEdit && _this5.canEdit(tokenName, tokenValue);

          if (_this5.filteredSearchInput.value === '' && lastVisualToken && canEdit) {
            backspaceCount += 1;

            if (backspaceCount === 2) {
              backspaceCount = 0;
              _this5.filteredSearchInput.value = gl.FilteredSearchVisualTokens.getLastTokenPartial();
              gl.FilteredSearchVisualTokens.removeLastTokenPartial();
            }
          }

          // Reposition dropdown so that it is aligned with cursor
          _this5.dropdownManager.updateCurrentDropdownOffset();
        } else {
          backspaceCount = 0;
        }
      };
    }
  }, {
    key: 'checkForEnter',
    value: function checkForEnter(e) {
      if (e.keyCode === 38 || e.keyCode === 40) {
        var selectionStart = this.filteredSearchInput.selectionStart;

        e.preventDefault();
        this.filteredSearchInput.setSelectionRange(selectionStart, selectionStart);
      }

      if (e.keyCode === 13) {
        var dropdown = this.dropdownManager.mapping[this.dropdownManager.currentDropdown];
        var dropdownEl = dropdown.element;
        var activeElements = dropdownEl.querySelectorAll('.droplab-item-active');

        e.preventDefault();

        if (!activeElements.length) {
          if (this.isHandledAsync) {
            e.stopImmediatePropagation();

            this.filteredSearchInput.blur();
            this.dropdownManager.resetDropdowns();
          } else {
            // Prevent droplab from opening dropdown
            this.dropdownManager.destroyDroplab();
          }

          this.search();
        }
      }
    }
  }, {
    key: 'addInputContainerFocus',
    value: function addInputContainerFocus() {
      addClassIfElementExists(this.filteredSearchInput.closest('.filtered-search-box'), 'focus');
    }
  }, {
    key: 'removeInputContainerFocus',
    value: function removeInputContainerFocus(e) {
      var inputContainer = this.filteredSearchInput.closest('.filtered-search-box');
      var isElementInFilteredSearch = inputContainer && inputContainer.contains(e.target);
      var isElementInDynamicFilterDropdown = e.target.closest('.filter-dropdown') !== null;
      var isElementInStaticFilterDropdown = e.target.closest('ul[data-dropdown]') !== null;

      if (!isElementInFilteredSearch && !isElementInDynamicFilterDropdown && !isElementInStaticFilterDropdown && inputContainer) {
        inputContainer.classList.remove('focus');
      }
    }
  }, {
    key: 'removeToken',
    value: function removeToken(e) {
      var removeButtonSelected = e.target.closest('.remove-token');

      if (removeButtonSelected) {
        e.preventDefault();
        // Prevent editToken from being triggered after token is removed
        e.stopImmediatePropagation();

        var button = e.target.closest('.selectable');
        gl.FilteredSearchVisualTokens.selectToken(button, true);
        this.removeSelectedToken();
      }
    }
  }, {
    key: 'unselectEditTokens',
    value: function unselectEditTokens(e) {
      var inputContainer = this.container.querySelector('.filtered-search-box');
      var isElementInFilteredSearch = inputContainer && inputContainer.contains(e.target);
      var isElementInFilterDropdown = e.target.closest('.filter-dropdown') !== null;
      var isElementTokensContainer = e.target.classList.contains('tokens-container');

      if (!isElementInFilteredSearch && !isElementInFilterDropdown || isElementTokensContainer) {
        gl.FilteredSearchVisualTokens.moveInputToTheRight();
        this.dropdownManager.resetDropdowns();
      }
    }
  }, {
    key: 'editToken',
    value: function editToken(e) {
      var token = e.target.closest('.js-visual-token');
      var sanitizedTokenName = token && token.querySelector('.name').textContent.trim();
      var canEdit = this.canEdit && this.canEdit(sanitizedTokenName);

      if (token && canEdit) {
        e.preventDefault();
        e.stopPropagation();
        gl.FilteredSearchVisualTokens.editToken(token);
        this.tokenChange();
      }
    }
  }, {
    key: 'toggleClearSearchButton',
    value: function toggleClearSearchButton() {
      var query = gl.DropdownUtils.getSearchQuery();
      var hidden = 'hidden';
      var hasHidden = this.clearSearchButton.classList.contains(hidden);

      if (query.length === 0 && !hasHidden) {
        this.clearSearchButton.classList.add(hidden);
      } else if (query.length && hasHidden) {
        this.clearSearchButton.classList.remove(hidden);
      }
    }
  }, {
    key: 'handleInputPlaceholder',
    value: function handleInputPlaceholder() {
      var query = gl.DropdownUtils.getSearchQuery();
      var placeholder = 'Search or filter results...';
      var currentPlaceholder = this.filteredSearchInput.placeholder;

      if (query.length === 0 && currentPlaceholder !== placeholder) {
        this.filteredSearchInput.placeholder = placeholder;
      } else if (query.length > 0 && currentPlaceholder !== '') {
        this.filteredSearchInput.placeholder = '';
      }
    }
  }, {
    key: 'removeSelectedTokenKeydown',
    value: function removeSelectedTokenKeydown(e) {
      // 8 = Backspace Key
      // 46 = Delete Key
      if (e.keyCode === 8 || e.keyCode === 46) {
        this.removeSelectedToken();
      }
    }
  }, {
    key: 'removeSelectedToken',
    value: function removeSelectedToken() {
      gl.FilteredSearchVisualTokens.removeSelectedToken();
      this.handleInputPlaceholder();
      this.toggleClearSearchButton();
      this.dropdownManager.updateCurrentDropdownOffset();
    }
  }, {
    key: 'onClearSearch',
    value: function onClearSearch(e) {
      e.preventDefault();
      this.clearSearch();
    }
  }, {
    key: 'clearSearch',
    value: function clearSearch() {
      var _this6 = this;

      this.filteredSearchInput.value = '';

      var removeElements = [];

      [].forEach.call(this.tokensContainer.children, function (t) {
        var canClearToken = t.classList.contains('js-visual-token');

        if (canClearToken) {
          var _gl$DropdownUtils$get2 = gl.DropdownUtils.getVisualTokenValues(t),
              tokenName = _gl$DropdownUtils$get2.tokenName,
              tokenValue = _gl$DropdownUtils$get2.tokenValue;

          canClearToken = _this6.canEdit && _this6.canEdit(tokenName, tokenValue);
        }

        if (canClearToken) {
          removeElements.push(t);
        }
      });

      removeElements.forEach(function (el) {
        el.parentElement.removeChild(el);
      });

      this.clearSearchButton.classList.add('hidden');
      this.handleInputPlaceholder();

      this.dropdownManager.resetDropdowns();

      if (this.isHandledAsync) {
        this.search();
      }
    }
  }, {
    key: 'handleInputVisualToken',
    value: function handleInputVisualToken() {
      var input = this.filteredSearchInput;

      var _tokenizer$processTok = this.tokenizer.processTokens(input.value, this.filteredSearchTokenKeys.getKeys()),
          tokens = _tokenizer$processTok.tokens,
          searchToken = _tokenizer$processTok.searchToken;

      var _gl$FilteredSearchVis2 = gl.FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          isLastVisualTokenValid = _gl$FilteredSearchVis2.isLastVisualTokenValid;

      if (isLastVisualTokenValid) {
        tokens.forEach(function (t) {
          input.value = input.value.replace(t.key + ':' + t.symbol + t.value, '');
          gl.FilteredSearchVisualTokens.addFilterVisualToken(t.key, '' + t.symbol + t.value);
        });

        var fragments = searchToken.split(':');
        if (fragments.length > 1) {
          var inputValues = fragments[0].split(' ');
          var tokenKey = underscore_default.a.last(inputValues);

          if (inputValues.length > 1) {
            inputValues.pop();
            var searchTerms = inputValues.join(' ');

            input.value = input.value.replace(searchTerms, '');
            gl.FilteredSearchVisualTokens.addSearchVisualToken(searchTerms);
          }

          gl.FilteredSearchVisualTokens.addFilterVisualToken(tokenKey);
          input.value = input.value.replace(tokenKey + ':', '');
        }
      } else {
        // Keep listening to token until we determine that the user is done typing the token value
        var valueCompletedRegex = /([~%@]{0,1}".+")|([~%@]{0,1}'.+')|^((?![~%@]')(?![~%@]")(?!')(?!")).*/g;

        if (searchToken.match(valueCompletedRegex) && input.value[input.value.length - 1] === ' ') {
          gl.FilteredSearchVisualTokens.addFilterVisualToken(searchToken);

          // Trim the last space as seen in the if statement above
          input.value = input.value.replace(searchToken, '').trim();
        }
      }
    }
  }, {
    key: 'handleFormSubmit',
    value: function handleFormSubmit(e) {
      e.preventDefault();
      this.search();
    }
  }, {
    key: 'saveCurrentSearchQuery',
    value: function saveCurrentSearchQuery() {
      var _this7 = this;

      // Don't save before we have fetched the already saved searches
      this.fetchingRecentSearchesPromise.then(function () {
        var searchQuery = gl.DropdownUtils.getSearchQuery();
        if (searchQuery.length > 0) {
          var resultantSearches = _this7.recentSearchesStore.addRecentSearch(searchQuery);
          _this7.recentSearchesService.save(resultantSearches);
        }
      }).catch(function () {
        // https://gitlab.com/gitlab-org/gitlab-ce/issues/30821
      });
    }

    // allows for modifying params array when a param can't be included in the URL (e.g. Service Desk)

  }, {
    key: 'getAllParams',
    value: function getAllParams(urlParams) {
      return this.modifyUrlParams ? this.modifyUrlParams(urlParams) : urlParams;
    }
  }, {
    key: 'loadSearchParamsFromURL',
    value: function loadSearchParamsFromURL() {
      var _this8 = this;

      var urlParams = gl.utils.getUrlParamsArray();
      var params = this.getAllParams(urlParams);
      var usernameParams = this.getUsernameParams();
      var hasFilteredSearch = false;

      params.forEach(function (p) {
        var split = p.split('=');
        var keyParam = decodeURIComponent(split[0]);
        var value = split[1];

        // Check if it matches edge conditions listed in this.filteredSearchTokenKeys
        var condition = _this8.filteredSearchTokenKeys.searchByConditionUrl(p);

        if (condition) {
          hasFilteredSearch = true;
          var canEdit = _this8.canEdit && _this8.canEdit(condition.tokenKey);
          gl.FilteredSearchVisualTokens.addFilterVisualToken(condition.tokenKey, condition.value, canEdit);
        } else {
          // Sanitize value since URL converts spaces into +
          // Replace before decode so that we know what was originally + versus the encoded +
          var sanitizedValue = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : value;
          var match = _this8.filteredSearchTokenKeys.searchByKeyParam(keyParam);

          if (match) {
            // Use lastIndexOf because the token key is allowed to contain underscore
            // e.g. 'my_reaction' is the token key of 'my_reaction_emoji'
            var lastIndexOf = keyParam.lastIndexOf('_');
            var sanitizedKey = lastIndexOf !== -1 ? keyParam.slice(0, lastIndexOf) : keyParam;
            // Replace underscore with hyphen in the sanitizedkey.
            // e.g. 'my_reaction' => 'my-reaction'
            sanitizedKey = sanitizedKey.replace('_', '-');
            var symbol = match.symbol;
            var quotationsToUse = '';

            if (sanitizedValue.indexOf(' ') !== -1) {
              // Prefer ", but use ' if required
              quotationsToUse = sanitizedValue.indexOf('"') === -1 ? '"' : '\'';
            }

            hasFilteredSearch = true;
            var _canEdit = _this8.canEdit && _this8.canEdit(sanitizedKey, sanitizedValue);
            gl.FilteredSearchVisualTokens.addFilterVisualToken(sanitizedKey, '' + symbol + quotationsToUse + sanitizedValue + quotationsToUse, _canEdit);
          } else if (!match && keyParam === 'assignee_id') {
            var id = parseInt(value, 10);
            if (usernameParams[id]) {
              hasFilteredSearch = true;
              var tokenName = 'assignee';
              var _canEdit2 = _this8.canEdit && _this8.canEdit(tokenName);
              gl.FilteredSearchVisualTokens.addFilterVisualToken(tokenName, '@' + usernameParams[id], _canEdit2);
            }
          } else if (!match && keyParam === 'author_id') {
            var _id = parseInt(value, 10);
            if (usernameParams[_id]) {
              hasFilteredSearch = true;
              var _tokenName = 'author';
              var _canEdit3 = _this8.canEdit && _this8.canEdit(_tokenName);
              gl.FilteredSearchVisualTokens.addFilterVisualToken(_tokenName, '@' + usernameParams[_id], _canEdit3);
            }
          } else if (!match && keyParam === 'search') {
            hasFilteredSearch = true;
            _this8.filteredSearchInput.value = sanitizedValue;
          }
        }
      });

      this.saveCurrentSearchQuery();

      if (hasFilteredSearch) {
        this.clearSearchButton.classList.remove('hidden');
        this.handleInputPlaceholder();
      }
    }
  }, {
    key: 'searchState',
    value: function searchState(e) {
      e.preventDefault();
      var target = e.currentTarget;
      // remove focus outline after click
      target.blur();

      var state = target.dataset && target.dataset.state;

      if (state) {
        this.search(state);
      }
    }
  }, {
    key: 'search',
    value: function search() {
      var _this9 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var paths = [];
      var searchQuery = gl.DropdownUtils.getSearchQuery();

      this.saveCurrentSearchQuery();

      var _tokenizer$processTok2 = this.tokenizer.processTokens(searchQuery, this.filteredSearchTokenKeys.getKeys()),
          tokens = _tokenizer$processTok2.tokens,
          searchToken = _tokenizer$processTok2.searchToken;

      var currentState = state || gl.utils.getParameterByName('state') || 'opened';
      paths.push('state=' + currentState);

      tokens.forEach(function (token) {
        var condition = _this9.filteredSearchTokenKeys.searchByConditionKeyValue(token.key, token.value.toLowerCase());

        var _ref2 = _this9.filteredSearchTokenKeys.searchByKey(token.key) || {},
            param = _ref2.param;
        // Replace hyphen with underscore to use as request parameter
        // e.g. 'my-reaction' => 'my_reaction'


        var underscoredKey = token.key.replace('-', '_');
        var keyParam = param ? underscoredKey + '_' + param : underscoredKey;
        var tokenPath = '';

        if (condition) {
          tokenPath = condition.url;
        } else {
          var tokenValue = token.value;

          if (tokenValue[0] === '\'' && tokenValue[tokenValue.length - 1] === '\'' || tokenValue[0] === '"' && tokenValue[tokenValue.length - 1] === '"') {
            tokenValue = tokenValue.slice(1, tokenValue.length - 1);
          }

          tokenPath = keyParam + '=' + encodeURIComponent(tokenValue);
        }

        paths.push(tokenPath);
      });

      if (searchToken) {
        var sanitized = searchToken.split(' ').map(function (t) {
          return encodeURIComponent(t);
        }).join('+');
        paths.push('search=' + sanitized);
      }

      var parameterizedUrl = '?scope=all&utf8=%E2%9C%93&' + paths.join('&');

      if (this.updateObject) {
        this.updateObject(parameterizedUrl);
      } else {
        Object(url_utility["g" /* visitUrl */])(parameterizedUrl);
      }
    }
  }, {
    key: 'getUsernameParams',
    value: function getUsernameParams() {
      var usernamesById = {};
      try {
        var attribute = this.filteredSearchInput.getAttribute('data-username-params');
        JSON.parse(attribute).forEach(function (user) {
          usernamesById[user.id] = user.username;
        });
      } catch (e) {
        // do nothing
      }
      return usernamesById;
    }
  }, {
    key: 'tokenChange',
    value: function tokenChange() {
      var dropdown = this.dropdownManager.mapping[this.dropdownManager.currentDropdown];

      if (dropdown) {
        var currentDropdownRef = dropdown.reference;

        this.setDropdownWrapper();
        currentDropdownRef.dispatchInputEvent();
      }
    }
  }, {
    key: 'onrecentSearchesItemSelected',
    value: function onrecentSearchesItemSelected(text) {
      this.clearSearch();
      this.filteredSearchInput.value = text;
      this.filteredSearchInput.dispatchEvent(new CustomEvent('input'));
      this.search();
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'canEdit',
    value: function canEdit() {
      return true;
    }
  }]);

  return FilteredSearchManager;
}();

window.gl = window.gl || {};
gl.FilteredSearchManager = filtered_search_manager_FilteredSearchManager;
// CONCATENATED MODULE: ./filtered_search/filtered_search_tokenizer.js
var filtered_search_tokenizer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtered_search_tokenizer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var FilteredSearchTokenizer = function () {
  function FilteredSearchTokenizer() {
    filtered_search_tokenizer__classCallCheck(this, FilteredSearchTokenizer);
  }

  filtered_search_tokenizer__createClass(FilteredSearchTokenizer, null, [{
    key: 'processTokens',
    value: function processTokens(input, allowedKeys) {
      // Regex extracts `(token):(symbol)(value)`
      // Values that start with a double quote must end in a double quote (same for single)
      var tokenRegex = new RegExp('(' + allowedKeys.join('|') + '):([~%@]?)(?:(\'[^\']*\'{0,1})|("[^"]*"{0,1})|(\\S+))', 'g');
      var tokens = [];
      var tokenIndexes = []; // stores key+value for simple search
      var lastToken = null;
      var searchToken = input.replace(tokenRegex, function (match, key, symbol, v1, v2, v3) {
        var tokenValue = v1 || v2 || v3;
        var tokenSymbol = symbol;
        var tokenIndex = '';

        if (tokenValue === '~' || tokenValue === '%' || tokenValue === '@') {
          tokenSymbol = tokenValue;
          tokenValue = '';
        }

        tokenIndex = key + ':' + tokenValue;

        // Prevent adding duplicates
        if (tokenIndexes.indexOf(tokenIndex) === -1) {
          tokenIndexes.push(tokenIndex);

          tokens.push({
            key: key,
            value: tokenValue || '',
            symbol: tokenSymbol || ''
          });
        }

        return '';
      }).replace(/\s{2,}/g, ' ').trim() || '';

      if (tokens.length > 0) {
        var last = tokens[tokens.length - 1];
        var lastString = last.key + ':' + last.symbol + last.value;
        lastToken = input.lastIndexOf(lastString) === input.length - lastString.length ? last : searchToken;
      } else {
        lastToken = searchToken;
      }

      return {
        tokens: tokens,
        lastToken: lastToken,
        searchToken: searchToken
      };
    }
  }]);

  return FilteredSearchTokenizer;
}();

window.gl = window.gl || {};
gl.FilteredSearchTokenizer = FilteredSearchTokenizer;
// EXTERNAL MODULE: ./api.js
var api = __webpack_require__("./api.js");

// EXTERNAL MODULE: ./lib/utils/cache.js
var cache = __webpack_require__("./lib/utils/cache.js");

// CONCATENATED MODULE: ./lib/utils/users_cache.js
var users_cache__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function users_cache__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function users_cache__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function users_cache__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var users_cache_UsersCache = function (_Cache) {
  users_cache__inherits(UsersCache, _Cache);

  function UsersCache() {
    users_cache__classCallCheck(this, UsersCache);

    return users_cache__possibleConstructorReturn(this, (UsersCache.__proto__ || Object.getPrototypeOf(UsersCache)).apply(this, arguments));
  }

  users_cache__createClass(UsersCache, [{
    key: 'retrieve',
    value: function retrieve(username) {
      var _this2 = this;

      if (this.hasData(username)) {
        return Promise.resolve(this.get(username));
      }

      return api["a" /* default */].users('', { username: username }).then(function (_ref) {
        var data = _ref.data;

        if (!data.length) {
          throw new Error('User "' + username + '" could not be found!');
        }

        if (data.length > 1) {
          throw new Error('Expected username "' + username + '" to be unique!');
        }

        var user = data[0];
        _this2.internalStorage[username] = user;
        return user;
      });
      // missing catch is intentional, error handling depends on use case
    }
  }]);

  return UsersCache;
}(cache["a" /* default */]);

/* harmony default export */ var users_cache = (new users_cache_UsersCache());
// CONCATENATED MODULE: ./filtered_search/filtered_search_visual_tokens.js
var filtered_search_visual_tokens__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtered_search_visual_tokens__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var filtered_search_visual_tokens_FilteredSearchVisualTokens = function () {
  function FilteredSearchVisualTokens() {
    filtered_search_visual_tokens__classCallCheck(this, FilteredSearchVisualTokens);
  }

  filtered_search_visual_tokens__createClass(FilteredSearchVisualTokens, null, [{
    key: 'getLastVisualTokenBeforeInput',
    value: function getLastVisualTokenBeforeInput() {
      var inputLi = container["a" /* default */].container.querySelector('.input-token');
      var lastVisualToken = inputLi && inputLi.previousElementSibling;

      return {
        lastVisualToken: lastVisualToken,
        isLastVisualTokenValid: lastVisualToken === null || lastVisualToken.className.indexOf('filtered-search-term') !== -1 || lastVisualToken && lastVisualToken.querySelector('.value') !== null
      };
    }
  }, {
    key: 'unselectTokens',
    value: function unselectTokens() {
      var otherTokens = container["a" /* default */].container.querySelectorAll('.js-visual-token .selectable.selected');
      [].forEach.call(otherTokens, function (t) {
        return t.classList.remove('selected');
      });
    }
  }, {
    key: 'selectToken',
    value: function selectToken(tokenButton) {
      var forceSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var selected = tokenButton.classList.contains('selected');
      FilteredSearchVisualTokens.unselectTokens();

      if (!selected || forceSelection) {
        tokenButton.classList.add('selected');
      }
    }
  }, {
    key: 'removeSelectedToken',
    value: function removeSelectedToken() {
      var selected = container["a" /* default */].container.querySelector('.js-visual-token .selected');

      if (selected) {
        var li = selected.closest('.js-visual-token');
        li.parentElement.removeChild(li);
      }
    }
  }, {
    key: 'createVisualTokenElementHTML',
    value: function createVisualTokenElementHTML() {
      var canEdit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      return '\n      <div class="' + (canEdit ? 'selectable' : 'hidden') + '" role="button">\n        <div class="name"></div>\n        <div class="value-container">\n          <div class="value"></div>\n          <div class="remove-token" role="button">\n            <i class="fa fa-close"></i>\n          </div>\n        </div>\n      </div>\n    ';
    }
  }, {
    key: 'setTokenStyle',
    value: function setTokenStyle(tokenContainer, backgroundColor, textColor) {
      var token = tokenContainer;

      // Labels with linear gradient should not override default background color
      if (backgroundColor.indexOf('linear-gradient') === -1) {
        token.style.backgroundColor = backgroundColor;
      }

      token.style.color = textColor;

      if (textColor === '#FFFFFF') {
        var removeToken = token.querySelector('.remove-token');
        removeToken.classList.add('inverted');
      }

      return token;
    }
  }, {
    key: 'preprocessLabel',
    value: function preprocessLabel(labelsEndpoint, labels) {
      var processed = labels;

      if (!labels.preprocessed) {
        processed = gl.DropdownUtils.duplicateLabelPreprocessing(labels);
        ajax_cache["a" /* default */].override(labelsEndpoint, processed);
        processed.preprocessed = true;
      }

      return processed;
    }
  }, {
    key: 'updateLabelTokenColor',
    value: function updateLabelTokenColor(tokenValueContainer, tokenValue) {
      var filteredSearchInput = container["a" /* default */].container.querySelector('.filtered-search');
      var baseEndpoint = filteredSearchInput.dataset.baseEndpoint;
      var labelsEndpoint = baseEndpoint + '/labels.json';

      return ajax_cache["a" /* default */].retrieve(labelsEndpoint).then(FilteredSearchVisualTokens.preprocessLabel.bind(null, labelsEndpoint)).then(function (labels) {
        var matchingLabel = (labels || []).find(function (label) {
          return '~' + gl.DropdownUtils.getEscapedText(label.title) === tokenValue;
        });

        if (!matchingLabel) {
          return;
        }

        FilteredSearchVisualTokens.setTokenStyle(tokenValueContainer, matchingLabel.color, matchingLabel.text_color);
      }).catch(function () {
        return new flash["a" /* default */]('An error occurred while fetching label colors.');
      });
    }
  }, {
    key: 'updateUserTokenAppearance',
    value: function updateUserTokenAppearance(tokenValueContainer, tokenValueElement, tokenValue) {
      if (tokenValue === 'none') {
        return Promise.resolve();
      }

      var username = tokenValue.replace(/^@/, '');
      return users_cache.retrieve(username).then(function (user) {
        if (!user) {
          return;
        }

        /* eslint-disable no-param-reassign */
        tokenValueContainer.dataset.originalValue = tokenValue;
        tokenValueElement.innerHTML = '\n          <img class="avatar s20" src="' + user.avatar_url + '" alt="">\n          ' + underscore_default.a.escape(user.name) + '\n        ';
        /* eslint-enable no-param-reassign */
      })
      // ignore error and leave username in the search bar
      .catch(function () {});
    }
  }, {
    key: 'updateEmojiTokenAppearance',
    value: function updateEmojiTokenAppearance(tokenValueContainer, tokenValueElement, tokenValue) {
      var container = tokenValueContainer;
      var element = tokenValueElement;

      return __webpack_require__.e/* import() */("emoji").then(__webpack_require__.bind(null, "./emoji/index.js")).then(function (Emoji) {
        if (!Emoji.isEmojiNameValid(tokenValue)) {
          return;
        }

        container.dataset.originalValue = tokenValue;
        element.innerHTML = Emoji.glEmojiTag(tokenValue);
      })
      // ignore error and leave emoji name in the search bar
      .catch(function () {});
    }
  }, {
    key: 'renderVisualTokenValue',
    value: function renderVisualTokenValue(parentElement, tokenName, tokenValue) {
      var tokenValueContainer = parentElement.querySelector('.value-container');
      var tokenValueElement = tokenValueContainer.querySelector('.value');
      tokenValueElement.innerText = tokenValue;

      var tokenType = tokenName.toLowerCase();
      if (tokenType === 'label') {
        FilteredSearchVisualTokens.updateLabelTokenColor(tokenValueContainer, tokenValue);
      } else if (tokenType === 'author' || tokenType === 'assignee') {
        FilteredSearchVisualTokens.updateUserTokenAppearance(tokenValueContainer, tokenValueElement, tokenValue);
      } else if (tokenType === 'my-reaction') {
        FilteredSearchVisualTokens.updateEmojiTokenAppearance(tokenValueContainer, tokenValueElement, tokenValue);
      }
    }
  }, {
    key: 'addVisualTokenElement',
    value: function addVisualTokenElement(name, value, isSearchTerm, canEdit) {
      var li = document.createElement('li');
      li.classList.add('js-visual-token');
      li.classList.add(isSearchTerm ? 'filtered-search-term' : 'filtered-search-token');

      if (value) {
        li.innerHTML = FilteredSearchVisualTokens.createVisualTokenElementHTML(canEdit);
        FilteredSearchVisualTokens.renderVisualTokenValue(li, name, value);
      } else {
        li.innerHTML = '<div class="name"></div>';
      }
      li.querySelector('.name').innerText = name;

      var tokensContainer = container["a" /* default */].container.querySelector('.tokens-container');
      var input = container["a" /* default */].container.querySelector('.filtered-search');
      tokensContainer.insertBefore(li, input.parentElement);
    }
  }, {
    key: 'addValueToPreviousVisualTokenElement',
    value: function addValueToPreviousVisualTokenElement(value) {
      var _FilteredSearchVisual = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          lastVisualToken = _FilteredSearchVisual.lastVisualToken,
          isLastVisualTokenValid = _FilteredSearchVisual.isLastVisualTokenValid;

      if (!isLastVisualTokenValid && lastVisualToken.classList.contains('filtered-search-token')) {
        var name = FilteredSearchVisualTokens.getLastTokenPartial();
        lastVisualToken.innerHTML = FilteredSearchVisualTokens.createVisualTokenElementHTML();
        lastVisualToken.querySelector('.name').innerText = name;
        FilteredSearchVisualTokens.renderVisualTokenValue(lastVisualToken, name, value);
      }
    }
  }, {
    key: 'addFilterVisualToken',
    value: function addFilterVisualToken(tokenName, tokenValue, canEdit) {
      var _FilteredSearchVisual2 = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          lastVisualToken = _FilteredSearchVisual2.lastVisualToken,
          isLastVisualTokenValid = _FilteredSearchVisual2.isLastVisualTokenValid;

      var addVisualTokenElement = FilteredSearchVisualTokens.addVisualTokenElement;

      if (isLastVisualTokenValid) {
        addVisualTokenElement(tokenName, tokenValue, false, canEdit);
      } else {
        var previousTokenName = lastVisualToken.querySelector('.name').innerText;
        var tokensContainer = container["a" /* default */].container.querySelector('.tokens-container');
        tokensContainer.removeChild(lastVisualToken);

        var value = tokenValue || tokenName;
        addVisualTokenElement(previousTokenName, value, false, canEdit);
      }
    }
  }, {
    key: 'addSearchVisualToken',
    value: function addSearchVisualToken(searchTerm) {
      var _FilteredSearchVisual3 = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          lastVisualToken = _FilteredSearchVisual3.lastVisualToken;

      if (lastVisualToken && lastVisualToken.classList.contains('filtered-search-term')) {
        lastVisualToken.querySelector('.name').innerText += ' ' + searchTerm;
      } else {
        FilteredSearchVisualTokens.addVisualTokenElement(searchTerm, null, true);
      }
    }
  }, {
    key: 'getLastTokenPartial',
    value: function getLastTokenPartial() {
      var _FilteredSearchVisual4 = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          lastVisualToken = _FilteredSearchVisual4.lastVisualToken;

      if (!lastVisualToken) return '';

      var valueContainer = lastVisualToken.querySelector('.value-container');
      var originalValue = valueContainer && valueContainer.dataset.originalValue;
      if (originalValue) {
        return originalValue;
      }

      var value = lastVisualToken.querySelector('.value');
      var name = lastVisualToken.querySelector('.name');

      var valueText = value ? value.innerText : '';
      var nameText = name ? name.innerText : '';

      return valueText || nameText;
    }
  }, {
    key: 'removeLastTokenPartial',
    value: function removeLastTokenPartial() {
      var _FilteredSearchVisual5 = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          lastVisualToken = _FilteredSearchVisual5.lastVisualToken;

      if (lastVisualToken) {
        var value = lastVisualToken.querySelector('.value');

        if (value) {
          var button = lastVisualToken.querySelector('.selectable');
          var valueContainer = lastVisualToken.querySelector('.value-container');
          button.removeChild(valueContainer);
          lastVisualToken.innerHTML = button.innerHTML;
        } else {
          lastVisualToken.closest('.tokens-container').removeChild(lastVisualToken);
        }
      }
    }
  }, {
    key: 'tokenizeInput',
    value: function tokenizeInput() {
      var input = container["a" /* default */].container.querySelector('.filtered-search');

      var _gl$FilteredSearchVis = gl.FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          isLastVisualTokenValid = _gl$FilteredSearchVis.isLastVisualTokenValid;

      if (input.value) {
        if (isLastVisualTokenValid) {
          gl.FilteredSearchVisualTokens.addSearchVisualToken(input.value);
        } else {
          FilteredSearchVisualTokens.addValueToPreviousVisualTokenElement(input.value);
        }

        input.value = '';
      }
    }
  }, {
    key: 'editToken',
    value: function editToken(token) {
      var input = container["a" /* default */].container.querySelector('.filtered-search');

      FilteredSearchVisualTokens.tokenizeInput();

      // Replace token with input field
      var tokenContainer = token.parentElement;
      var inputLi = input.parentElement;
      tokenContainer.replaceChild(inputLi, token);

      var nameElement = token.querySelector('.name');
      var value = void 0;

      if (token.classList.contains('filtered-search-token')) {
        FilteredSearchVisualTokens.addFilterVisualToken(nameElement.innerText);

        var valueContainerElement = token.querySelector('.value-container');
        value = valueContainerElement.dataset.originalValue;

        if (!value) {
          var valueElement = valueContainerElement.querySelector('.value');
          value = valueElement.innerText;
        }
      }

      // token is a search term
      if (!value) {
        value = nameElement.innerText;
      }

      input.value = value;

      // Opens dropdown
      var inputEvent = new Event('input');
      input.dispatchEvent(inputEvent);

      // Adds cursor to input
      input.focus();
    }
  }, {
    key: 'moveInputToTheRight',
    value: function moveInputToTheRight() {
      var input = container["a" /* default */].container.querySelector('.filtered-search');

      if (!input) return;

      var inputLi = input.parentElement;
      var tokenContainer = container["a" /* default */].container.querySelector('.tokens-container');

      FilteredSearchVisualTokens.tokenizeInput();

      if (!tokenContainer.lastElementChild.isEqualNode(inputLi)) {
        var _gl$FilteredSearchVis2 = gl.FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
            isLastVisualTokenValid = _gl$FilteredSearchVis2.isLastVisualTokenValid;

        if (!isLastVisualTokenValid) {
          var lastPartial = gl.FilteredSearchVisualTokens.getLastTokenPartial();
          gl.FilteredSearchVisualTokens.removeLastTokenPartial();
          gl.FilteredSearchVisualTokens.addSearchVisualToken(lastPartial);
        }

        tokenContainer.removeChild(inputLi);
        tokenContainer.appendChild(inputLi);
      }
    }
  }]);

  return FilteredSearchVisualTokens;
}();

window.gl = window.gl || {};
gl.FilteredSearchVisualTokens = filtered_search_visual_tokens_FilteredSearchVisualTokens;
// CONCATENATED MODULE: ./filtered_search/filtered_search_bundle.js











/***/ }),

/***/ "./filtered_search/filtered_search_dropdown.js":
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DATA_DROPDOWN_TRIGGER = 'data-dropdown-trigger';

var FilteredSearchDropdown = function () {
  function FilteredSearchDropdown(_ref) {
    var droplab = _ref.droplab,
        dropdown = _ref.dropdown,
        input = _ref.input,
        filter = _ref.filter;

    _classCallCheck(this, FilteredSearchDropdown);

    this.droplab = droplab;
    this.hookId = input && input.id;
    this.input = input;
    this.filter = filter;
    this.dropdown = dropdown;
    this.loadingTemplate = '<div class="filter-dropdown-loading">\n      <i class="fa fa-spinner fa-spin"></i>\n    </div>';
    this.bindEvents();
  }

  _createClass(FilteredSearchDropdown, [{
    key: 'bindEvents',
    value: function bindEvents() {
      this.itemClickedWrapper = this.itemClicked.bind(this);
      this.dropdown.addEventListener('click.dl', this.itemClickedWrapper);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      this.dropdown.removeEventListener('click.dl', this.itemClickedWrapper);
    }
  }, {
    key: 'getCurrentHook',
    value: function getCurrentHook() {
      var _this = this;

      return this.droplab.hooks.filter(function (h) {
        return h.id === _this.hookId;
      })[0] || null;
    }
  }, {
    key: 'itemClicked',
    value: function itemClicked(e, getValueFunction) {
      var selected = e.detail.selected;


      if (selected.tagName === 'LI' && selected.innerHTML) {
        var dataValueSet = gl.DropdownUtils.setDataValueIfSelected(this.filter, selected);

        if (!dataValueSet) {
          var value = getValueFunction(selected);
          gl.FilteredSearchDropdownManager.addWordToInput(this.filter, value, true);
        }

        this.resetFilters();
        this.dismissDropdown();
        this.dispatchInputEvent();
      }
    }
  }, {
    key: 'setAsDropdown',
    value: function setAsDropdown() {
      this.input.setAttribute(DATA_DROPDOWN_TRIGGER, '#' + this.dropdown.id);
    }
  }, {
    key: 'setOffset',
    value: function setOffset() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (window.innerWidth > 480) {
        this.dropdown.style.left = offset + 'px';
      } else {
        this.dropdown.style.left = '0px';
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var forceShowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var currentHook = this.getCurrentHook();
      if (forceShowList && currentHook && currentHook.list.hidden) {
        currentHook.list.show();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var forceRenderContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var forceShowList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.setAsDropdown();

      var currentHook = this.getCurrentHook();
      var firstTimeInitialized = currentHook === null;

      if (firstTimeInitialized || forceRenderContent) {
        this.renderContent(forceShowList);
      } else if (currentHook.list.list.id !== this.dropdown.id) {
        this.renderContent(forceShowList);
      }
    }
  }, {
    key: 'dismissDropdown',
    value: function dismissDropdown() {
      // Focusing on the input will dismiss dropdown
      // (default droplab functionality)
      this.input.focus();
    }
  }, {
    key: 'dispatchInputEvent',
    value: function dispatchInputEvent() {
      // Propogate input change to FilteredSearchDropdownManager
      // so that it can determine which dropdowns to open
      this.input.dispatchEvent(new CustomEvent('input', {
        bubbles: true,
        cancelable: true
      }));
    }
  }, {
    key: 'dispatchFormSubmitEvent',
    value: function dispatchFormSubmitEvent() {
      // dispatchEvent() is necessary as form.submit() does not
      // trigger event handlers
      this.input.form.dispatchEvent(new Event('submit'));
    }
  }, {
    key: 'hideDropdown',
    value: function hideDropdown() {
      var currentHook = this.getCurrentHook();
      if (currentHook) {
        currentHook.list.hide();
      }
    }
  }, {
    key: 'resetFilters',
    value: function resetFilters() {
      var hook = this.getCurrentHook();

      if (hook) {
        var data = hook.list.data || [];
        var results = data.map(function (o) {
          var updated = o;
          updated.droplab_hidden = false;
          return updated;
        });
        hook.list.render(results);
      }
    }
  }]);

  return FilteredSearchDropdown;
}();

window.gl = window.gl || {};
gl.FilteredSearchDropdown = FilteredSearchDropdown;

/***/ })

},["./filtered_search/filtered_search_bundle.js"]);


// WEBPACK FOOTER //
// filtered_search.cb0514753e270981541b.bundle.js